<template>
  <div>

    

      <!-- Main content -->
      <section class="content">
        <div class="error-page">
          <h2 class="headline text-yellow">404</h2>

          <div class="error-content">
            <h3>
              <i class="fa fa-warning text-yellow"></i> Oops! Page not found.
            </h3>

            <p>
              We could not find the page you were looking for. Meanwhile, you
              may <router-link to="/">return to dashboard</router-link> or try
              using the search form.
            </p>

          </div>
          <!-- /.error-content -->
        </div>
        <!-- /.error-page -->
      </section>

  </div>
</template>

<script>
export default {name: '404'}
</script>



// WEBPACK FOOTER //
// Error.vue?f5659558